import { t } from "i18next";
import { FC, useContext } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

import Checkbox from "@app/components/inputs/Checkbox";
import { BranchSettingsFormData } from "@app/types/BranchSettings";
import { AppContext } from "@app/utils/contexts/App.context";

interface BranchSettingsFormProps {
    data: BranchSettingsFormData;
    onChange: (_name: string, _value: string | boolean) => void;
}

const BranchSettingsForm: FC<BranchSettingsFormProps> = ({ data, onChange }) => {
    const { userPermissions } = useContext(AppContext);

    return (
        <Container fluid className='py-4 px-5'>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label className='text-input__label mb-4'>Select Features</Form.Label>
                        <div className='d-flex'>
                            <Checkbox
                                checked={data.BULK_LICENSEE}
                                label={t("BRANCHSETTINGS.CHECKBOXLABEL.BULK")}
                                onClick={() => onChange("BULK_LICENSEE", !data.BULK_LICENSEE)}
                                testId='bulk-checkbox'
                                className="branch-settings-checkbox"
                            />
                            {userPermissions &&
                                (userPermissions["Read_Auto Pumping"] ||
                                    userPermissions["Edit_Auto Pumping"]) && (
                                    <Checkbox
                                        checked={data.AUTOPUMP_LICENSEE}
                                        label={t("BRANCHSETTINGS.CHECKBOXLABEL.AUTOPUMPING")}
                                        onClick={() =>
                                            onChange("AUTOPUMP_LICENSEE", !data.AUTOPUMP_LICENSEE)
                                        }
                                        testId='auto-pump-checkbox'
                                        disabled={
                                            userPermissions && !userPermissions["Edit_Auto Pumping"]
                                        }
                                        className="branch-settings-checkbox"
                                    />
                                )}
                            {userPermissions?.["Read_Consume Overdue"] && (
                                <Checkbox
                                    checked={data?.CONSUME_OVERDUE_LICENSEE}
                                    label={t("BRANCHSETTINGS.CHECKBOXLABEL.CONSUMEOVERDUE")}
                                    onClick={() =>
                                        onChange(
                                            "CONSUME_OVERDUE_LICENSEE",
                                            !data?.CONSUME_OVERDUE_LICENSEE,
                                        )
                                    }
                                    testId='consume-overdue-checkbox'
                                    disabled={
                                        !(
                                            data?.CONSUME_OVERDUE_ADMIN &&
                                            userPermissions?.["Edit_Consume Overdue"]
                                        )
                                    }
                                    className="branch-settings-checkbox"
                                />
                            )}
                        </div>
                    </Form.Group>
                </Col>
            </Row>
        </Container>
    );
};

export default BranchSettingsForm;
